<template>
  <!-- 消息通知 -->
  <div>
    <section v-if="noticeIf==false" class="main-wrap">
      <div class="goods-head">
        <div class="slider-list">
          <div class="item selected">消息通知</div>
        </div>
        <!-- 查询表单  -->
        <el-form
          ref="queryForm"
          class="queryForm"
          :model="searchData"
          label-position="right"
          label-width="7rem"
        >
          <el-row>
            <el-col :span="18">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="标题名称：" prop="noticeTitle">
                    <el-input v-model="searchData.noticeTitle" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="消息类型：" prop="noticeType">
                    <el-select v-model="searchData.noticeType" placeholder="请选择">
                      <el-option label="运力" value="1" />
                      <el-option label="货源" value="2" />
                      <el-option label="订单" value="102" />
                      <el-option label="报价" value="104" />
                      <el-option label="预约" value="105" />
                      <el-option label="审批" value="108" />
                      <el-option label="资质认证" value="101" />
                      <el-option label="运单生成" value="103" />
                      <el-option label="司机任务" value="106" />
                      <el-option label="运输调度" value="107" />
                      <el-option label="系统公告" value="109" />
                      <el-option label="推荐联系人" value="110" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="通知日期：" prop="time">
                    <el-date-picker
                      v-model="searchData.time"
                      type="daterange"
                      :editable="false"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <div class="query-btn" @click="queryListClick">
                <i class="iconfont iconsousuo" />查询
              </div>
              <div class="reset-btn" @click="resetForm('queryForm')">
                <i class="iconfont el-icon-delete-solid" />重置
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="main">
        <div class="main-box">
          <template v-if="noticeListData.length < 1">
            <div class="no-data-info">
              <font>暂无匹配数据</font>
            </div>
          </template>
          <template v-else>
            <div
              v-for="(item,index) in noticeListData"
              :key="index"
              class="main-item"
              :class="[{'main-item-read':item.isRead==1}]"
            >
              <div class="main-item-left">
                <div class="main-item-icon" @click="popNoticeClick(item.id)">
                  <i class="iconfont iconiconfonthuodonggonggao" />
                  <div v-if="item.isRead!=1" class="main-item-icon-dot" />
                </div>
                <div class="main-item-con" @click="popNoticeClick(item.id)">
                  <p class="main-item-con-title">{{ item.noticeTitle }}</p>
                  <p class="main-item-con-txt">{{ item.noticeContent }}</p>
                </div>
              </div>
              <div class="main-item-right">
                <p class="main-item-time">{{ item.createDate }}</p>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!--分页-->
      <article class="main-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </article>
    </section>
    <!--<section v-if="noticeIf==true" class="notice-wrap">-->
    <!--<div class="notice-header">-->
    <!--<p class="notice-header-title">{{ detailsData.noticeTitle }}</p>-->
    <!--<p class="notice-header-time">时间：{{ detailsData.createDate }}</p>-->
    <!--</div>-->
    <!--<div class="notice-con">-->
    <!--{{ detailsData.noticeContent }}-->
    <!--&lt;!&ndash;请及时处理，如已处理，请忽略此消息！&ndash;&gt;-->
    <!--</div>-->
    <!--<div class="notice-btn-box">-->
    <!--<div v-if='detailsData.noticeType!=110' class="notice-btn" @click="noticeDetails(detailsData.noticeType,detailsData.isMark,detailsData.id,detailsData)">-->
    <!--查看详情-->
    <!--</div>-->
    <!--<div  class="notice-btn-return" @click="noticeReturn()">-->
    <!--返回-->
    <!--</div>-->
    <!--</div>-->
    <!--</section>-->
    <detailsDome v-if="noticeIf==true" :details-con="detailsData" @detailsRet="noticeReturn" />
  </div>
</template>
<script>
import * as get from '@/api/personal/user/news-notice/index.js' // 请求接口
import { Page } from '@/utils/commonDataModel'
import { mapGetters } from 'vuex'
import detailsDome from './components/details.vue'
export default {
  name: 'NewsNotice',
  components: {
    detailsDome
  },
  data() {
    return {
      searchData: {
        noticeTitle: '', // 标题名称
        noticeType: '', // 消息类型
        time: '' // 时间
      },
      // 列表
      noticeListData: [],
      // 详情
      // detailsData: {},
      // 表格分页
      pagination: new Page(),
      // 是否详情页
      noticeIf: false,
      // 获取用户id
      userId: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.userId = this.userInfo.userId
  },
  mounted() {
    this.getListData(this.pagination)
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.queryListClick()
      }
    }
  },
  methods: {
    // 获取列表
    getListData(data) {
      get
        .getNoticeList(Object.assign(data, { userId: this.userInfo.userId }))
        .then(res => {
          console.log(res)
          this.pagination.total = Number(res.result.total)
          this.pagination.pageNo = Number(res.result.pageNo)
          this.pagination.pageSize = Number(res.result.pageSize)
          this.noticeListData = res.result.rows || []
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 分页-第几页
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.getListData(this.pagination)
    },
    // 分页-每页多少条
    changeSize(size) {
      this.pagination.pageSize = size
      this.getListData(this.pagination)
    },
    // 跳转详情页
    popNoticeClick(id) {
      get.getDetails({ id: id, isRead: '1' }).then(res => {
        this.detailsData = res.result
        // console.log(res)
        // const jsonNoticeModuleVal = JSON.parse(res.result.noticeModuleVal)
        const jsonNoticeModuleVal = eval(
          '(' + res.result.noticeModuleVal + ')'
        )
        this.detailsData.noticeModuleVal = jsonNoticeModuleVal
        console.log(this.detailsData)
        this.noticeIf = true
      })
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.getListData(this.pagination)
    },
    // 表单查询
    queryListClick() {
      console.log('回车查询')
      const odata = {
        noticeTitle: this.searchData.noticeTitle,
        noticeType: this.searchData.noticeType,
        startSportDate: this.searchData.time[0],
        stopSportDate: this.searchData.time[1],
        userId: this.userInfo.userId
      }
      get
        .getNoticeList(odata)
        .then(res => {
          console.log(odata.startSportDate==res.result.rows.createDate)

          console.log(res,'11111111')
          this.pagination.total = res.result.total
          this.pagination.pageNo = res.result.pageNo
          this.pagination.pageSize = res.result.pageSize
          this.noticeListData = res.result.rows || []
        })
        .catch(error => {
          console.log(error)
        })
    },

    // // 查看详情
    // noticeDetails(data, isMark, id, con) {
    //   this.getListData()
    //   this.noticeIf = false
    //   switch (data) {
    //     case '101':
    //       if (isMark == 1) {
    //         this.$router.push({
    //           name: 'QualificationsAuthen',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       } else if (isMark == 2) {
    //         this.$router.push({
    //           name: 'QualificationsAuthen',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       } else if (isMark == 3) {
    //         this.$router.push({
    //           name: 'QualificationsAuthen',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       }
    //       break // 资质认证
    //     case '102':
    //       if (isMark == 1) {
    //         this.$router.push({
    //           name: 'OrderList',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       } else if (isMark == 2) {
    //         this.$router.push({
    //           name: 'OrderList',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       } else if (isMark == 3) {
    //         this.$router.push({
    //           name: 'OrderList',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       } else if (isMark == 4) {
    //         this.$router.push({
    //           name: 'OrderList',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       }
    //       break // 订单列表
    //     case '103':
    //       if (isMark == 1) {
    //         this.$router.push({
    //           name: 'TransportList',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       } else if (isMark == 2) {
    //         this.$router.push({
    //           name: 'TransportList',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       } else if (isMark == 3) {
    //         this.$router.push({
    //           name: 'TransportList',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       }
    //       break // 运单生成
    //     case '104':
    //       if (isMark == 1) {
    //         this.$router.push({
    //           name: 'GoodsList',
    //           params: { noticeId: id, noticeMark: isMark, data: con }
    //         })
    //       } else if (isMark == 2) {
    //         this.$router.push({
    //           name: 'GoodsList',
    //           params: { noticeId: id, noticeMark: isMark, data: con }
    //         })
    //       } else if (isMark == 3) {
    //         this.$router.push({
    //           name: 'GoodsList',
    //           params: { noticeId: id, noticeMark: isMark, data: con }
    //         })
    //       }
    //       break // 货源列表
    //     case '105':
    //       if (isMark == 1) {
    //         this.$router.push({
    //           name: 'MyAppointment',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       } else if (isMark == 2) {
    //         this.$router.push({
    //           name: 'MyAppointment',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       } else if (isMark == 3) {
    //         this.$router.push({
    //           name: 'MyAppointment',
    //           params: { noticeId: id, noticeMark: isMark }
    //         })
    //       }
    //       break // 预约
    //     case '110':
    //       this.$router.push({
    //         name: 'contacts',
    //         params: { noticeId: id, noticeMark: isMark }
    //       })
    //       break // 联系人
    //     default:
    //       return
    //   }
    // },

    // 详情返回列表
    noticeReturn(data) {
      this.noticeIf = data
      this.getListData(this.pagination)
    }
  }
}
</script>
<style scoped lang='scss'>
$main-color: #be2316;
.goods-head {
  padding: 12px 12px;
  box-sizing: border-box;
  border-color: #f1f1f1;
  background-color: #ffffff;
  width: 928px;
  height: auto;
  border: 1px solid #dddddd;
  .slider-list {
    display: block;
    margin: 0 0;
    height: 36px;
    overflow: auto;
    white-space: nowrap;
    border-bottom: 1px solid #f1f1f1;
    &::-webkit-scrollbar {
      height: 0px !important;
      width: 0px !important;
    }
    /*&::-moz-scrollbar {*/
    /*height: 0px !important;*/
    /*width: 0px !important;*/
    /*}*/
    .item {
      // height: 35px;
      height: calc(100% - 1px);
      display: inline-block;
      width: 100px;
      font-size: 16px;
      font-weight: 600;
      line-height: 35px;
      margin-right: 12px;
      border-bottom: 1px solid rgba(0, 0, 0, 0);
      text-align: center;
      transition: all 1s;
      color: black;
      cursor: pointer;

      &.selected {
        border-bottom: 1px solid $main-color;
        transition: all 1s;
        color: $main-color;
      }
    }
  }
  .queryForm {
    margin-top: 30px;
    .el-form-item {
      margin-bottom: 12px !important;
    }
    .query-btn {
      float: left;
      width: 68px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      background: #be2316;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      border-radius: 4px;
      margin-left: 20px;
    }
    .reset-btn {
      float: left;
      width: 68px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      background: #be2316;
      color: #fff;
      font-size: 14px;
      border: 1px solid #be2316;
      cursor: pointer;
      border-radius: 4px;
      margin-left: 20px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }
  }
}
.main {
  min-height: 550px;
  border-color: #f1f1f1;
  background-color: #ffffff;
  margin-top: 10px;
  padding: 20px 20px 50px 20px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #dddddd;
  .main-item {
    width: 100%;
    height: 90px;
    border-bottom: 1px solid rgba(204, 204, 204, 0.5);
    .main-item-left {
      float: left;
      width: 80%;
      height: 90px;
      .main-item-icon {
        position: relative;
        margin-top: 26px;
        float: left;
        cursor: pointer;
        i {
          font-size: 36px;
        }
        .main-item-icon-dot {
          position: absolute;
          right: -6px;
          top: -4px;
          width: 8px;
          height: 8px;
          background: #be2316;
          border-radius: 50%;
        }
      }
      .main-item-con {
        float: left;
        margin-left: 10px;
        cursor: pointer;
        .main-item-con-title {
          color: #333333;
          font-size: 16px;
          font-weight: bold;
          padding-top: 22px;
        }
        .main-item-con-txt {
          font-size: 14px;
          color: #666666;
          padding-top: 10px;
        }
      }
    }
    .main-item-right {
      float: left;
      width: 20%;
      height: 90px;
      .main-item-time {
        text-align: right;
        font-size: 14px;
        color: #666666;
        margin-top: 20px;
      }
    }
    &.main-item-read {
      .main-item-left {
        .main-item-icon {
          i {
            color: #b7b7b7;
          }
        }
        .main-item-con {
          .main-item-con-title {
            color: #a1a1a1;
          }
          .main-item-con-txt {
            color: #b3b3b3;
          }
        }
      }
      .main-item-right {
        .main-item-time {
          color: #b3b3b3;
        }
      }
    }
  }
}
.main-pagination {
  width: 100%;
  padding: 16px 0px;
  margin-top: 24px;
  background-color: white;
  box-sizing: border-box;
  border: 1px solid #dddddd;
}
.notice-wrap {
  background-color: #ffffff;
  padding: 40px 80px 20px 80px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  .notice-header {
    padding-bottom: 30px;
    .notice-header-title {
      font-size: 24px;
      /*font-weight: bold;*/
      color: #333333;
      text-align: center;
      padding-bottom: 20px;
    }
    .notice-header-time {
      font-size: 14px;
      text-align: center;
      color: #999999;
    }
  }
  .notice-con {
    color: #555555;
    font-size: 14px;
  }
  .notice-btn-box {
    width: 100%;
    height: auto;
    text-align: center;
    .notice-btn {
      display: inline-block;
      width: 136px;
      height: 40px;
      line-height: 40px;
      background: #be2316;
      color: #fff;
      font-size: 18px;
      text-align: center;
      border-radius: 4px;
      margin-top: 50px;
      cursor: pointer;
      margin-right: 15px;
    }
    .notice-btn-return {
      display: inline-block;
      width: 136px;
      height: 40px;
      line-height: 40px;
      background: #be2316;
      color: #fff;
      font-size: 18px;
      text-align: center;
      border-radius: 4px;
      margin-top: 50px;
      cursor: pointer;
    }
  }
}
</style>
